document.addEventListener('DOMContentLoaded', function() {
    function toUrlFriendly(text) {
        if (!text) return '';
        return String(text).trim().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
    }

    function formatEngineForUrlParam(engineText) {
        if (!engineText) return '';
        // Example: "1.5 8v 90bg dizel" will remain "1.5 8v 90bg dizel"
        // The browser will convert spaces to '+' upon form submission for URL parameters.
        return String(engineText).trim();
    }

    function enhanceSearchForm(formElement) {
        const storedVehicle = localStorage.getItem('selectedVehicleForSearch');
        if (storedVehicle) {
            try {
                const vehicle = JSON.parse(storedVehicle);
                if (vehicle.make && vehicle.model && vehicle.year && vehicle.engine) {
                    // console.log('Vehicle found in localStorage, enhancing search form:', vehicle);

                    // Ensure 'type=product' and 'options[prefix]=last' are present
                    let typeInput = formElement.querySelector('input[name="type"][value="product"]');
                    if (!typeInput) {
                        typeInput = document.createElement('input');
                        typeInput.type = 'hidden';
                        typeInput.name = 'type';
                        typeInput.value = 'product';
                        formElement.appendChild(typeInput);
                    }

                    let optionsPrefixInput = formElement.querySelector('input[name="options[prefix]"][value="last"]');
                    if (!optionsPrefixInput) {
                        optionsPrefixInput = document.createElement('input');
                        optionsPrefixInput.type = 'hidden';
                        optionsPrefixInput.name = 'options[prefix]';
                        optionsPrefixInput.value = 'last';
                        formElement.appendChild(optionsPrefixInput);
                    }

                    // Add vehicle filters as hidden inputs
                    const filters = {
                        'filter.p.m.custom.make': vehicle.make, // Use raw value as per example
                        'filter.p.m.custom.model': vehicle.model, // Use raw value
                        'filter.p.m.custom.multiyear': vehicle.year, // Use raw value
                        'filter.p.m.custom.multiengine': formatEngineForUrlParam(vehicle.engine) // Format for URL param
                    };

                    for (const key in filters) {
                        if (Object.prototype.hasOwnProperty.call(filters, key)) {
                            let hiddenInput = formElement.querySelector(`input[name="${key}"]`);
                            if (hiddenInput) {
                                hiddenInput.value = filters[key]; // Update if exists
                            } else {
                                hiddenInput = document.createElement('input');
                                hiddenInput.type = 'hidden';
                                hiddenInput.name = key;
                                hiddenInput.value = filters[key];
                                formElement.appendChild(hiddenInput);
                            }
                        }
                    }
                    // console.log('Form enhanced with vehicle filters.');
                } else {
                    // console.log('Incomplete vehicle in localStorage, not enhancing search form.');
                }
            } catch (e) {
                console.error('Error processing vehicle from localStorage for search enhancement:', e);
            }
        } else {
            // console.log('No vehicle in localStorage, not enhancing search form.');
        }
    }

    // Target forms with action '/search' or containing an input with name 'q'
    // This covers most Shopify search forms.
    const searchForms = document.querySelectorAll('form[action="/search"], form[action="{{ routes.search_url }}"], form:has(input[name="q"])');
    // console.log(`Found ${searchForms.length} search forms.`);

    searchForms.forEach(form => {
        form.addEventListener('submit', function(event) {
            // console.log('Search form submitted:', form);
            enhanceSearchForm(form);
            // The form will now submit with the added/updated hidden inputs
        });
    });

    // Special handling for predictive search if it dynamically creates forms or changes query params
    // This might require more specific selectors based on the theme's predictive search implementation
    // For now, we rely on the submit event of forms believed to be search forms.
}); 